import { useMutation } from '@tanstack/react-query'
import { Download } from 'lucide-react'
import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import { downloadAuditPackage, type PackageScope } from '@/models/vault'
import { useVault } from './VaultContext'

/** Downloads the audit package: the current document in every slot, zipped, with a manifest of the gaps. */
export function AuditPackageButton({
  kind,
  entityId,
  label = 'Download audit package',
  variant = 'ghost',
  size = 'sm',
}: {
  kind?: PackageScope
  entityId?: string
  label?: string
  /** The whole fleet's package leads the page; a section's sits back from it. */
  variant?: 'default' | 'outline' | 'ghost'
  size?: 'sm' | 'default'
}) {
  const { orgId } = useVault()
  const download = useMutation({
    mutationFn: () => downloadAuditPackage(orgId, kind, entityId),
    onError: () => toast.error('Could not build the audit package.'),
  })

  return (
    <Button
      size={size}
      variant={variant}
      loading={download.isPending ? 'Building package…' : undefined}
      onClick={() => download.mutate()}
    >
      <Download />
      {label}
    </Button>
  )
}
